// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__13WuA","title":"style_title__z+a2C","slogan":"style_slogan__wpLKf"};